<template>
  <!-- Two buttons that act as one choice, like a segmented control. -->
  <div class="tt" role="radiogroup" aria-label="Appearance" @keydown="onKeydown">
    <button
      v-for="opt in options"
      :key="opt.value"
      ref="buttons"
      type="button"
      role="radio"
      class="tt-btn"
      :class="{ 'tt-active': theme === opt.value }"
      :aria-checked="theme === opt.value ? 'true' : 'false'"
      :aria-label="opt.label"
      :title="opt.label"
      :tabindex="theme === opt.value ? 0 : -1"
      @click="choose(opt.value)"
    >
      <component :is="opt.icon" :size="16" aria-hidden="true" />
    </button>
  </div>
</template>

<script>
import { Sun, Moon } from 'lucide-vue-next';
import { getTheme, setTheme } from '../../utils/theme';

export default {
  name: 'ThemeToggle',
  data() {
    return {
      theme: getTheme(),
      options: [
        { value: 'light', label: 'Light appearance', icon: Sun },
        { value: 'dark', label: 'Dark appearance', icon: Moon },
      ],
    };
  },
  methods: {
    choose(value) {
      this.theme = value;
      setTheme(value);
    },
    // Arrow keys move between the two, as a radio group does.
    onKeydown(e) {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
      e.preventDefault();
      const i = this.options.findIndex(o => o.value === this.theme);
      const step = e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 1;
      const next = (i + step + this.options.length) % this.options.length;
      this.choose(this.options[next].value);
      this.$nextTick(() => this.$refs.buttons?.[next]?.focus());
    },
  },
};
</script>

<style scoped>
.tt {
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  background: var(--color-surface-muted);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-full);
}

.tt-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: var(--radius-full);
  background: transparent;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.tt-btn:hover {
  color: var(--color-text);
}

.tt-active {
  background: var(--color-surface);
  color: var(--color-accent);
  box-shadow: var(--shadow-sm);
}
</style>
